/* eslint-disable @typescript-eslint/no-explicit-any */
//TODO: this file has to be renamed with actual route (search/default) before this page deploys in UAT
import { ResponsiveGrid } from '@adobe/aem-react-editable-components';
import { ApolloProvider } from '@apollo/client';
import { GetServerSideProps } from 'next';

import { MOCK_SESSION_ID, getSessionData, prePageCall } from '@marriott/mi-headless-utils';
import { Layout, respGridUtil } from '@marriott/mi-headless-utils';
import operationSignatures from '../../_constants/operationSignatures.json';
import { getDeployedEnvType, useNextMiApolloClient } from '@marriott/mi-apollo-client-utils';
import { inspect } from 'util';
import { FEATURE_FLAGS, fetchFlag, TARGETS } from '@marriott/mi-feature-flag-utils';

export default function AdvanceSearchPage({ model, pagePath, isAuthorMode }) {
  const MiApolloClient = useNextMiApolloClient(operationSignatures, getDeployedEnvType());

  const {
    metaNames,
    metaProperties,
    title,
    staticComponentClientLibsCSS,
    staticComponentClientLibsJS,
    gridCss,
    hreflangList,
    canonical,
  } = model;
  const respGridModel = respGridUtil(model?.cqItems?.root?.[':items']?.responsivegrid);

  return (
    <ApolloProvider client={MiApolloClient}>
      <Layout
        metaNames={metaNames}
        metaProps={metaProperties}
        title={title}
        staticComponentClientLibsCSS={staticComponentClientLibsCSS}
        staticComponentClientLibsJS={staticComponentClientLibsJS}
        isAuthorMode={isAuthorMode}
        gridCss={gridCss || ''}
        hreflangList={hreflangList}
        canonical={canonical}
        USE_MOCK_MODEL={process.env['USE_MOCK_MODEL'] === 'true'}
      >
        <section>
          <ResponsiveGrid
            key={pagePath}
            {...respGridModel}
            model={respGridModel}
            pagePath={pagePath}
            itemPath="root/responsivegrid"
          />
        </section>
      </Layout>
    </ApolloProvider>
  );
}

const {
  GOOGLE_MAP_API_KEY,
  BAIDU_MAP_API_KEY,
  MI_DATALAYER_APP_URL,
  NEXT_PUBLIC_DATALAYER_SITENAME,
  NEXT_PUBLIC_DATALAYER_PRODUCT,
  NEXT_PUBLIC_DATALAYER_APPLICATION,
  NEXT_PUBLIC_DATALAYER_TEMPLATE,
  NEXT_PUBLIC_DATALAYER_VARIATION,
  NEXT_PUBLIC_ORIENTATION_LANDSCAPE,
  NEXT_PUBLIC_ORIENTATION_PORTRAIT,
  NEXT_PUBLIC_PATHTYPE_NEW,
  NEXT_PUBLIC_PATHTYPE_LEGACY,
  NEXT_PUBLIC_SEARCH_SINGLE_RATE,
  NEXT_PUBLIC_RAM_TILE_NAME,
  NEXT_PUBLIC_PAGE_BREAKPT,
  NEXT_PUBLIC_SEARCH_MAPVIEW,
  NEXT_PUBLIC_SEARCH_LISTVIEW,
  DEPLOYED_ENV_CONFIG,
  ENABLE_ADV_SEARCH_DATALAYER_CALL,
  SESSION_GET_CALL_URL_CLIENT,
  NEXT_PUBLIC_SUBMIT_SEARCH_URL,
  NEXT_PUBLIC_AVAILABILITY_SEARCH_URL,
  IS_LOCAL_DEV,
  SESSION_APP_GET_CALL_URL,
  SESSION_APP_POST_CALL_URL,
  GROUPS_DEV_URL,
  GROUPS_TEST_URL,
  NEXT_PUBLIC_PREFIX,
  GET_DESTINATION_TYPE_FLAG,
} = process.env;

const advSearchFormSpecificData = async ({ req, resolvedUrl }) => {
  const { log } = global.loggerInstance('HotelDirectory:');
  const resolvedUrlString: string = resolvedUrl ?? req.url;
  log.debug(inspect(`[ADV-SEARCH-LOGS] SESSION resolvedUrl IS:${inspect(resolvedUrlString)}`));

  const isAuthorMode = resolvedUrlString.includes('isAuthorMode');
  log.debug(inspect(`[ADV-SEARCH-LOGS] SESSION isAuthorMode IS:${inspect(isAuthorMode)}`));

  const sessionId = req?.cookies?.sessionID ?? MOCK_SESSION_ID;
  log.debug(inspect(`[ADV-SEARCH-LOGS] SESSION ID :${inspect(sessionId)}`));
  const requestId = req.headers['x-request-id'];

  const sessionDoc: any = await getSessionData(sessionId, IS_LOCAL_DEV === 'true', isAuthorMode, requestId);
  log.debug(inspect(`[ADV-SEARCH-LOGS] SESSION DOC :${inspect(sessionDoc)}`));
  const featureFlagLogo = await fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_LOGO_AUTOMATION, {
    target: TARGETS.APP.SHOP_RENDERER,
    enableStream: true,
  });
  //Fetch concurFlow feature flag
  const featureFlagEnableConcurFlow = await fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_ENABLE_CONCUR_FLOW, {
    target: TARGETS.APP.SHOP_RENDERER,
    enableStream: true,
  });

  return {
    featureFlagLogo,
    sessionFetchedData: sessionDoc.sessionData,
    GOOGLE_MAP_API_KEY,
    BAIDU_MAP_API_KEY,
    datalayerParams: {
      MI_DATALAYER_APP_URL,
      NEXT_PUBLIC_DATALAYER_SITENAME,
      NEXT_PUBLIC_DATALAYER_PRODUCT,
      NEXT_PUBLIC_DATALAYER_APPLICATION,
      NEXT_PUBLIC_DATALAYER_TEMPLATE,
      NEXT_PUBLIC_DATALAYER_VARIATION,
    },
    datalayerProperties: {
      NEXT_PUBLIC_ORIENTATION_LANDSCAPE,
      NEXT_PUBLIC_ORIENTATION_PORTRAIT,
      NEXT_PUBLIC_PATHTYPE_NEW,
      NEXT_PUBLIC_PATHTYPE_LEGACY,
      NEXT_PUBLIC_SEARCH_SINGLE_RATE,
      NEXT_PUBLIC_RAM_TILE_NAME,
      NEXT_PUBLIC_PAGE_BREAKPT,
      NEXT_PUBLIC_SEARCH_MAPVIEW,
      NEXT_PUBLIC_SEARCH_LISTVIEW,
    },
    DEPLOYED_ENV_CONFIG,
    GROUPS_DEV_URL,
    GROUPS_TEST_URL,
    ENABLE_ADV_SEARCH_DATALAYER_CALL,
    SESSION_GET_CALL_URL_CLIENT,
    NEXT_PUBLIC_SUBMIT_SEARCH_URL,
    NEXT_PUBLIC_AVAILABILITY_SEARCH_URL,
    SESSION_APP_GET_CALL_URL,
    SESSION_APP_POST_CALL_URL,
    DAC_IMG_DOMAIN: process.env['DAC_IMG_DOMAIN'],
    NEXT_PUBLIC_PREFIX,
    GET_DESTINATION_TYPE_FLAG,
    featureFlagEnableConcurFlow: featureFlagEnableConcurFlow ?? null,
  };
};

const mockModel = async () => {
  if (process.env['NODE_ENV'] === 'development') {
    // nx-ignore-next-line
    const { TabbedSearchFormMock } = await import('@marriott/mi-shop-components'); //Load mock model dynamically only for dev mode
    return TabbedSearchFormMock;
  }
  return {};
};

//SSR Render
export const getServerSideProps: GetServerSideProps<any> = prePageCall(advSearchFormSpecificData, mockModel);
